import {ActionHandlerBase} from "../action-handler-base";
import {IOpenLinkActionData, IPerformActionTopicPayload} from "@sparkware/uc-sdk-core";
import {ExternalLinkViewMode} from "../../../external-links/external-links.service.interface";

export class OpenLinkActionHandler extends ActionHandlerBase {
    async handle(payload: IPerformActionTopicPayload): Promise<void> {
        const actionData = payload.actionData as IOpenLinkActionData;
        if(!actionData?.url) {
            this.services.logger.error('No url provided for openLink action');
            return;
        }

        let view: ExternalLinkViewMode = 'window';
        if(!actionData.openExternally) {
            view = 'redirect';
        }

        await this.services.externalLinks.openLink({
            sourceLink: actionData.url?.trim(),
            view: view
        });
    }
}